export const SearchBar = ({ value, onInput, onKeyPress }) => {
  return (
    <div className="uk-width-expand">
      <form
        className="uk-search uk-width-expand"
        onSubmit={(e) => e.preventDefault()}
      >
        <span className="uk-search-icon-flip" uk-search-icon="" ></span>
        <input
          className="uk-search-input"
          type="search"
          placeholder="Search..."
		  value={value}
		  // [+-] dc: use appropriate events
          onInput={(e) => onInput(e.target.value)}
          onKeyPress={(e) => onKeyPress(e.key)}
        />
      </form>
    </div>
  );
};
